<template>
  <div class="recorder-page">
    <div class="recorder-video">
      <div class="player">
        <wss-player v-if="stream!==null"
                    style="background: #000;height: 100%;"
                    :stream="stream"
                    @reconnect="reconnect"
                    @capture-picture="capturePicture"/>
      </div>
      <div class="recorder-data">
        <div class="recorder-h"><span></span>{{ selectedRow.userNickname || "-" }}视角</div>
        <div class="recorder-p">执法设备号：{{ selectedRow.serialNO || "-" }}</div>
      </div>
    </div>
    <div class="recorder-ul">
      <div class="recorder-li" v-for="(row,index) in list" @click="chooseRow(row)">
        <div class="recorder-laber"><span>{{ row.roleName }}</span>{{ row.userNickname }}<p v-if="row['state'] === '在线'"/></div>
        <div class="recorder-laber"><span>设备号</span>{{ row.serialNO }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import WssPlayer from "@/components/player/WssPlayer.vue";
import { getHikStreamVO, listDevice } from "@/api/hik";

export default {
  name: "recorder",
  components: {WssPlayer},
  data() {
    return {
      stream: null,
      list: [],
      selectedRow: {}
    }
  },
  created() {
    this.listDevice();
  },
  async mounted() {
    // const result = await listUserCameraVO()
    // this.list = result.data
    // this.playHikStream()
  },
  methods: {
    //进入主系统
    async listDevice() {
      this.list = await listDevice()
      // if (this.list.length > 0) {
      //   this.chooseRow(this.list[0])
      // }
    },
    chooseRow(row) {
      if (this.selectedRow.serialNO !== row.serialNO) {
        this.selectedRow = row
        this.playHikStream()
      }
    },
    // 获取视频播放地址
    async playHikStream() {
      try {
        this.stream = await getHikStreamVO(this.selectedRow.serialNO)
      } catch (e) {
        // this.$message.error(e)
      }
    },
    // 播放断开重连
    reconnect({key, protocol}) {
      console.log({key, protocol})
      this.playHikStream()
    },
    // 视频截图
    capturePicture(base64) {
    }
  }
}
</script>

<style lang="less" scoped>
.recorder-page {
  margin-top: 30px;

  .recorder-ul {
    display: flex;
    align-items: center;
    overflow: auto;
    width: 100%;

    .recorder-li {
      border: 1px solid #324467;
      padding: 8px;
      margin-right: 8px;
      cursor: pointer;

      .recorder-laber:first-child {
        margin-bottom: 8px;
        color: #C2D9F5;
      }

      .recorder-laber {
        display: flex;
        align-items: center;
        color: rgba(194, 217, 245, 0.65);
        font-size: 14px;

        p {
          width: 6px;
          background: #AAF688;
          border-radius: 50%;
          height: 6px;
          margin: 0;
          margin-left: 4px;
        }

        span {
          background: #293752;
          color: #C2D9F5;
          font-size: 12px;
          height: 20px;
          width: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
        }
      }
    }
  }

  .recorder-video {
    position: relative;
    margin-bottom: 12px;

    .player {
      width: 450px;
      height: 253px;
      background: #000;
      border: 1px solid #324467;
      display: block;
    }

    .recorder-data {
      position: absolute;
      left: 0;
      top: 0;
      padding: 8px;
      font-size: 14px;
      text-align: left;

      .recorder-h.active {
        span {
          background: #eee;
        }
      }

      .recorder-h {
        color: #FFF;
        display: flex;
        align-items: center;

        span {
          width: 6px;
          background: #AAF688;
          border-radius: 50%;
          height: 6px;
          margin-right: 5px;
        }
      }

      .recorder-p {
        color: rgba(255, 255, 255, 0.65);
        margin-top: 6px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/largescreen/components/recorder.vue